import classnames from 'classnames';
import createReactClass from 'create-react-class';
import React from 'react';
import PropTypes from 'prop-types';

import Err from 'models/err';
import LoadingSpinner from 'components/lib/loading_spinner';
import PasswordField from './lib/password_field';
import PasswordHints from './lib/password_hints';
import UserAuthLayout from './lib/user_auth_layout';
import UserCredential from 'models/user_credential';
import UserCredentialType from 'models/user_credential_type';
import UserButton, { UserActionButton } from 'components/user/lib/user_button';

const UserResetPassword = createReactClass({
  propTypes: {
    currentAgentId: PropTypes.string.isRequired,
    errors: PropTypes.arrayOf(PropTypes.instanceOf(Err)).isRequired,
    isPasswordResetPending: PropTypes.bool.isRequired,
    isUserAuthorized: PropTypes.bool.isRequired,
    onNavigateToLogin: PropTypes.func.isRequired,
    onNavigateToForgotPassword: PropTypes.func.isRequired,
    onResetPassword: PropTypes.func.isRequired,
  },

  getInitialState() {
    return {
      hasPasswordChangedSinceLastSubmit: false,
      isSubmitted: false,
      password: '',
    };
  },

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.isPasswordResetPending && !nextProps.isPasswordResetPending && nextProps.errors.length) {
      this.setState({ isSubmitted: false });
    }
  },

  render() {
    if (!this.props.isUserAuthorized) {
      return this.renderUserUnauthorized();
    }

    if (this.state.isSubmitted && !this.props.isPasswordResetPending && !this.props.errors.length) {
      return this.renderPasswordResetComplete();
    }

    return this.renderPasswordResetForm();
  },

  renderUserUnauthorized() {
    return (
      <UserAuthLayout
        className="userResetPasswordForm-layout userResetPassword-failure"
        title="Password Reset Failed"
        message={
          <div>
            <p className="userResetPassword-failure-message">The password reset link is invalid</p>
            <p className="userResetPassword-failure-message">or has expired.</p>
          </div>
        }
      >
        <div className="userAuthLayout-proceedLinkContainer form-group">
          <UserButton
            className="userAuthLayout-button userAuthLayout-button-navigateToForgotPassword"
            onClick={this.props.onNavigateToForgotPassword}
          >
            Reset password again
          </UserButton>
        </div>
      </UserAuthLayout>
    );
  },

  renderPasswordResetComplete() {
    return (
      <UserAuthLayout
        className="userResetPasswordForm-layout userResetPassword-success"
        displayLogo
        image={<div className="userResetPassword-completeImage" />}
        message={
          <div>
            <p>Success! Your password reset is complete.</p>
            <p>Please log in with your new password.</p>
          </div>
        }
        title="Your password has changed"
      >
        <div className="userAuthLayout-proceedLinkContainer">
          <div className="form-group">
            <UserButton
              className="userAuthLayout-button userAuthLayout-button-navigateToLogin"
              onClick={this.props.onNavigateToLogin}
            >
              Sign In
            </UserButton>
          </div>
        </div>
      </UserAuthLayout>
    );
  },

  renderPasswordResetForm() {
    const image = this.props.isPasswordResetPending ? (
      <LoadingSpinner />
    ) : (
      <div className="userResetPassword-resetImage" />
    );

    const passwordContainerClassNames = classnames('userAuthLayout-passwordContainer', {
      'userAuthLayout-passwordContainer-hasSubmitErrors': this.getSubmitErrors().length > 0,
    });

    return (
      <UserAuthLayout
        className="userResetPasswordForm-layout"
        displayLogo
        image={image}
        onLogoClick={this.props.onNavigateToLogin}
        title="Reset your password"
      >
        <div className="userAuthLayout-formContainer userResetPassword-formContainer">
          <form className="login-form" onSubmit={this.handleResetPassword}>
            <div className="userAuthLayout-formElementsContainer">
              <div className="userAuthLayout-formElements">
                <div className="userResetPassword-message">Enter your new password</div>
                <div className={passwordContainerClassNames}>
                  <PasswordField
                    autoFocus
                    className="userAuthLayout-form-input userAuthLayout-passwordInput"
                    onBlur={this.handleBlur}
                    onChange={this.handlePasswordChange}
                    onFocus={this.handleFocus}
                    onSubmit={this.handleResetPassword}
                    value={this.state.password}
                  />
                </div>
                <div className="form-group">{this.renderCompleteResetButton()}</div>
              </div>
              <PasswordHints
                errors={getPasswordValidationErrors(this.state.password).concat(this.getSubmitErrors())}
                password={this.state.password}
                hasDifferentPasswordRequirement
              />
            </div>
          </form>
        </div>
      </UserAuthLayout>
    );
  },

  renderCompleteResetButton() {
    const disabled = this.isSubmitDisabled();
    let classNames = classnames('userAuthLayout-form-button userAuthLayout-form-completePasswordReset', {
      disabled,
    });
    return (
      <UserActionButton className={classNames} disabled={disabled} onClick={this.handleResetPassword}>
        Change Password
      </UserActionButton>
    );
  },

  handlePasswordChange(password) {
    this.setState({ password, hasPasswordChangedSinceLastSubmit: true });
  },

  handleResetPassword(ev) {
    ev.preventDefault();

    if (!this.isSubmitDisabled()) {
      this.props.onResetPassword({ id: this.props.currentAgentId, password: this.state.password });
      this.setState({ isSubmitted: true, hasPasswordChangedSinceLastSubmit: false });
    }
  },

  getSubmitErrors() {
    return this.state.hasPasswordChangedSinceLastSubmit ? [] : this.props.errors;
  },

  isSubmitDisabled() {
    return (
      !this.state.password ||
      getPasswordValidationErrors(this.state.password).length > 0 ||
      (!this.state.hasPasswordChangedSinceLastSubmit && this.props.errors.length > 0)
    );
  },
});

export function getPasswordValidationErrors(password) {
  return UserCredential.getValidationErrors(UserCredentialType.RESET_PASSWORD_TOKEN, { password }).concat(
    UserCredential.trimAndValidatePassword(password)
  );
}

export default UserResetPassword;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/user/user_reset_password.jsx